module.exports = __webpack_public_path__ + "img/Recurso 38@300x.97ba6d84.png";